import { render, staticRenderFns } from "./ProfilePasswordFormInvira.vue?vue&type=template&id=165c1327&scoped=true&"
import script from "./ProfilePasswordFormInvira.vue?vue&type=script&lang=js&"
export * from "./ProfilePasswordFormInvira.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePasswordFormInvira.vue?vue&type=style&index=0&id=165c1327&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c1327",
  null
  
)

export default component.exports